"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.convoTags.name': 'Tag Conversazione',
    'tools.convoTags.description': 'Aggiungi tag rilevanti alle conversazioni basati sul contesto',
};
